import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-legend_line",
  "use": "icon-legend_line-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-legend_line\">\n<path d=\"M2 7V9H0V7H2ZM10 7V9H6V7H10ZM16 7V9H14V7H16Z\" fill=\"#8A7BA3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol